import { render, staticRenderFns } from "./NavbarUserMenu.vue?vue&type=template&id=cc83cfd4&"
import script from "./NavbarUserMenu.vue?vue&type=script&lang=js&"
export * from "./NavbarUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc83cfd4')) {
      api.createRecord('cc83cfd4', component.options)
    } else {
      api.reload('cc83cfd4', component.options)
    }
    module.hot.accept("./NavbarUserMenu.vue?vue&type=template&id=cc83cfd4&", function () {
      api.rerender('cc83cfd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/NavbarUserMenu.vue"
export default component.exports